import { api } from "./BackendService";

export const create = (data) => api.post("/admin-users", data);
export const deleteById = (id) => api.delete(`/admin-users/${id}`);
export const edit = (id, data) => api.put(`/admin-users/${id}`, data);
export const getById = (id) => api.get(`/admin-users/${id}`);
export const list = (page) =>
  api.get("/admin-users", { params: { page: page } });
